<script setup lang="ts">
import { useEditTexts, VENUE_CONTACT } from '@/composables/useEditTexts';

const t = useEditTexts();
</script>

<template>
  <p class="edit-contact" data-testid="edit-contact">
    {{ t.edit_contact }}
    <a :href="`mailto:${VENUE_CONTACT.email}`">{{ VENUE_CONTACT.email }}</a>
    ·
    <a :href="VENUE_CONTACT.phoneHref">{{ VENUE_CONTACT.phone }}</a>
  </p>
</template>

<style scoped>
.edit-contact {
  margin: 8px 0;
}
</style>
